<template>
  <div v-if="demoType === 'freemium'" class="trial-control-container">
    
    <div v-if="isUnfold">
      <AppLink
        v-if="$checkPermission(['admin', 'diamond'])"
        to="/setting/subscription-and-billing-v2/manage"
        class="trial-unfold"
      >
        <span class="status">Free Subscription</span>
        <span class="buy-btn">
          Upgrade
          <svg-icon class="buy-icon" name="ic-left-more"></svg-icon>
        </span>
      </AppLink>
      <div v-else class="trial-unfold">
        <span class="status">Free Subscription</span>
      </div>
    </div>
    <div v-else class="trial trial-closure">
      <span class="status">Free</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AppLink from './link.vue'
export default {
  name: 'TrialControl',
  components: { AppLink },
  props: {
    isUnfold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      demoType: state => state.user.demoType,
    }),
  },
}
</script>
<style lang="scss" scoped>
.trial-control-container {
  // margin-top: 12px;
  width: 100%;
  height: 36px;
  padding: 0px 12px 10px;
  background: #001c4f;
  .trial {
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    .status {
      font-family: OpenSans-Bold, sans-serif;
      font-size: 12px;
      color: #fff;
    }
  }
  .trial-expired {
    margin: 0 -7px;
    background-color: #cc581d;
    &.is-unfold {
      margin: 0;
    }
  }
  .trial-closure {
    background-color: #0abc4e;
  }
  .trial-unfold {
    padding: 5px 10px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    background-color: #0abc4e;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
    .status {
      flex: 1;
      font-family: OpenSans-Bold, sans-serif;
      font-size: 12px;
      color: #fff;
    }
    .buy-btn {
      flex-shrink: 0;
      margin-left: 5px;
      display: flex;
      align-items: center;
      font-family: OpenSans-Bold, sans-serif;
      font-size: 12px;
      color: #fff;
      .buy-icon {
        flex-shrink: 0;
        font-size: 12px;
      }
    }
  }
}
</style>
